import { render } from "./CalculatorAboutYouSection.vue?vue&type=template&id=6f44ebeb&scoped=true&ts=true&lang=pug"
import script from "./CalculatorAboutYouSection.vue?vue&type=script&lang=ts&setup=true"
export * from "./CalculatorAboutYouSection.vue?vue&type=script&lang=ts&setup=true"

import "./CalculatorAboutYouSection.vue?vue&type=style&index=0&id=6f44ebeb&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f44ebeb"]])

export default __exports__